import { MessageDescriptor, defineMessages } from "react-intl";
import { LineItemErrorCode, ReplenishmentErrorCodes } from "@deliverr/replenishment-client";
import { BulkProductUploadConstants } from "./BulkProductUploadConstants";

export const BULK_PRODUCT_UPLOAD_ERROR_MESSAGES: Record<string, MessageDescriptor> = defineMessages({
  [ReplenishmentErrorCodes.FILE_MISSING]: {
    id: "bulkProductUpload.error.fileMissing",
    defaultMessage: "File not found. Please re-upload.",
  },
  [ReplenishmentErrorCodes.SHEET_NOT_FOUND]: {
    id: "bulkProductUpload.error.sheetNotFound",
    defaultMessage: `Sheet "${BulkProductUploadConstants.SHEET_TO_PROCESS}" not found. Please check file and try again`,
  },
  [ReplenishmentErrorCodes.INVALID_INPUT]: {
    id: "bulkProductUpload.error.invalidInput",
    defaultMessage: `File has incorrect column headers. Please ensure the column headers in row ${BulkProductUploadConstants.HEADER_ROW} and match the expected format.`,
  },
  [ReplenishmentErrorCodes.EMPTY_SHEET]: {
    id: "bulkProductUpload.error.emptySheet",
    defaultMessage: "File is empty. Please add data and try again.",
  },
  [ReplenishmentErrorCodes.MAX_DSKUS_LIMIT_REACHED]: {
    id: "bulkProductUpload.error.maxDskusLimitReached",
    defaultMessage: `File exceeds the maximum limit of ${BulkProductUploadConstants.MAX_SKUS} rows. Please reduce rows and try again`,
  },
  [ReplenishmentErrorCodes.FILE_BAD_EXTENSION]: {
    id: "bulkProductUpload.error.fileBadExtension",
    defaultMessage: "Unsupported file type ({fileType}). Please use XLSX or CSV",
  },
  [ReplenishmentErrorCodes.VALIDATION_ERROR]: {
    id: "bulkProductUpload.error.validationError",
    defaultMessage: "Errors in uploaded file. Please review the details and fix the issues.",
  },
  [ReplenishmentErrorCodes.MISSING_DSKU_FOR_MSKU]: {
    id: "bulkProductUpload.error.missingDskuForMsku",
    defaultMessage: "Row {entityId}: Either MSKU or DSKU is required.",
  },
  [ReplenishmentErrorCodes.TOTAL_UNITS_NOT_DIVISIBLE_BY_CASE_QTY]: {
    id: "bulkProductUpload.error.totalUnitsNotDivisibleByCaseQty",
    defaultMessage:
      "Row {entityId}: The total units ({totalUnits}) must be divisible by the units per box ({unitsPerBox}).",
  },
  [ReplenishmentErrorCodes.TOTAL_UNITS_NOT_EQUAL_TO_BOXES]: {
    id: "bulkProductUpload.error.totalUnitsNotEqualToBoxes",
    defaultMessage:
      "Row {entityId}: Total units ({totalUnits}) ≠ units per box ({unitsPerBox}) × number of boxes ({numberOfBoxes}).",
  },
  [ReplenishmentErrorCodes.DUPLICATE_ITEMS_IN_ORDER]: {
    id: "bulkProductUpload.error.duplicateItemsInOrder",
    defaultMessage: "SKU {sku} in multiple lines (rows {firstOccurrence}, {currentOccurrence}).",
  },
  [LineItemErrorCode.PRODUCT_NOT_FOUND]: {
    id: "bulkProductUpload.error.productNotFound",
    defaultMessage: "Row {rowNumber}: Product SKU {sku} not found. Please verify and try again.",
  },
  [LineItemErrorCode.MULTIPLE_MATCHING_DSKUS]: {
    id: "bulkProductUpload.error.multipleMatchingDskus",
    defaultMessage: "Row {rowNumber}: Multiple DSKUs found for MSKU {sku}. Please specify DSKU.",
  },
  [LineItemErrorCode.CASE_PACK_NOT_FOUND]: {
    id: "bulkProductUpload.error.casePackNotFound",
    defaultMessage: "Row {rowNumber}: Case pack ({unitsPerBox} units per box) for SKU {sku} is missing.",
  },
  [LineItemErrorCode.INSUFFICIENT_INVENTORY]: {
    id: "bulkProductUpload.error.insufficientInventory",
    defaultMessage: "Row {rowNumber}: Insufficient inventory for SKU {sku}.",
  },
  [LineItemErrorCode.LOT_NOT_FOUND]: {
    id: "bulkProductUpload.error.lotNotFound",
    defaultMessage: "Row {rowNumber}: Lot ({lotNumber}) for SKU {sku} not found. Please verify and try again.",
  },
  [LineItemErrorCode.FAILED_TO_RESOLVE_LINE_ITEM]: {
    id: "bulkProductUpload.error.failedToResolveLineItem",
    defaultMessage: "Row {rowNumber}: Error resolving the row. Please try again or contact support.",
  },
  [ReplenishmentErrorCodes.INVALID_ORDER_ITEMS]: {
    id: "bulkProductUpload.error.invalidOrderItems",
    defaultMessage: "Invalid products in upload. Please check the indicated rows and fix the errors.",
  },
});
